// extracted by mini-css-extract-plugin
module.exports = {"helloWorld":"style_helloWorld__13ocD"};